import { render } from "./Podcast.vue?vue&type=template&id=4afcf709"
import script from "./Podcast.vue?vue&type=script&lang=js"
export * from "./Podcast.vue?vue&type=script&lang=js"

import "./Podcast.vue?vue&type=style&index=0&id=4afcf709&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__